import { Tools } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const SparePartIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Tools width={size} height={size} color={color} {...rest} />;

SparePartIcon.displayName = 'SparePartIcon';

export default SparePartIcon;
